import PackAction from './PackAction.es6';
import NewCollectionAction from "./NewCollectionAction.es6";
import ProgressButton from "../progressButton";
import Modaller from "./../modaller";

require('jquery-form')($);
require('jsrender')($);

export default class PackAddToCollectionAction extends PackAction {
    constructor(opts) {
        super(opts);

        this.collectionItemTemplate = $.templates(`
<li class="user-collections-select-list__item">
    <a href="#" class="btn btn-pressed" data-course="{{:id}}">{{>title}}</a>
</li>
`);
    }

    getTitleKey() {
        return 'packPage.dialogs.addToCollection.title';
    }

    _showModal(modal) {
        const form = modal.content.find('form');

        modal.setTitle(this.l18n.get(this.getTitleKey()));
        modal.centerFooterButtons();
        modal.addFooterButton(this.l18n.get('button.save'), "btn btn-primary btn-ok", function () {
            form.find('input[name="collections"]').remove();
            modal.content.find('.user-collections-select-list__item a.btn-pressed').each(function () {
                form.append(`<input type=hidden name=collections value="${$(this).data('course')}">`);
            });
            form.submit();
        });
        modal.addFooterButton(this.l18n.get('button.cancel'), "btn btn-secondary btn-cancel", function () {
            modal.close();
        });
        modal.content.on('click', '.user-collections-select-list__item a', e => {
            $(e.currentTarget).toggleClass('btn-pressed');
        });
        modal.content.find('[data-click=newCollection]').click(() => {
            modal.content.hide();

            new NewCollectionAction({
                l18n: this.opts.l18n,
                onComplete: (dialog) => {
                    if (dialog.result !== null) {
                        const itemHtml = this.collectionItemTemplate.render({
                            id: dialog.result.groupId,
                            title: dialog.result.groupName
                        });

                        modal.content.find('.user-collections-select-list__new')
                            .before(itemHtml);
                    }
                    modal.content.show();
                }
            }).execute();

            return false;
        });

        form.ajaxForm({
            beforeSubmit: function () {
                new ProgressButton(modal.content.find('button.btn-ok')).progress = true;
            },
            success: function () {
                modal.close();
            }
        });

        this._onModalShown();
    }

    execute() {
        Modaller.showRemote(`${Flashcards.root}/set/${this.opts.packId}/add-to-collection.ajax`
            , $.proxy(this._showModal, this)
            , (xhr) => {
                if (xhr.status !== 403) {
                    return;
                }
                Modaller.showForbidden(this.l18n, 'packPage.dialogs.addToCollection.title', 'packPage.dialogs.addToCollection.forbidden');
            });
    }
}
